import {leafletPageLinks} from "./onlinesale.js";
import {leafletAutoHeightTitle} from './tools.js';
import Config from './config.js';
import { initZoomLeaflet } from './leaflet-zoom';

$(function ()
{
    leafletAutoHeightTitle('.flyerName');
    leafletAutoHeightTitle('.tr-banner-name');

    $('.icoArrowGrayBigLeft').hover(function(){
        $('.icoArrowGrayBigLeft').css({"background-position" : "-346px -94px"});

    }, function(){
        $('.icoArrowGrayBigLeft').css({"background-position" : "-346px -125px"});
    });

    $('.icoArrowGrayBig').hover(function(){
        $('.icoArrowGrayBig').css({"background-position" : "-368px -94px"});

    }, function(){
        $('.icoArrowGrayBig').css({"background-position" : "-368px -125px"});
    });

    // leták už src vyplněný má a měl by být načtený, pro jistotu ověříme
    // on load nefunguje, protože nyní máme URL obrázku již v src, takže se do on load nedostane
    if ($('#leaflet').length) {
        leafletPageLinks();

        // přepočítám vrstu
        $(window).resize(function() {

            // zrušíme původní
            const leafletPage = document.getElementById('leaflet-page-id');

            if (leafletPage)
            {
                leafletPage.parentNode.removeChild(leafletPage);
            }

            leafletPageLinks();
        });
    }
    
    rightBannersBehave();
    gaInitPushClassicLeaflet();
    initCanvasImage();
    fixPaginatorPosition();
    initZoomLeaflet();
});

function rightBannersBehave()
{
    if( $('.leaflet-detail-big').height() < $('#rightBanner1').height() + $('#rightBanner2').height() + $('#rightBanner3').height() + 32)
    {
        $('#rightBanner3').css({display: 'none'});
    }           
}

/**
 * GA měření prokliků letáku na web obchodníka.
 */
function gaInitPushClassicLeaflet() {
    $('.ga-classic-leaflet').on('click', function () {
        let ga = Config.get('classicLeafletPageGa');

        // pokud se nám z presenteru nepředalo, nebudeme pokračovat
        if (ga === null) {
            return;
        }

        gtag('event', 'leták proklik', {
            'event_category': ga.storeName,
            'event_label': ga.leafletUrl,
        });
    });
}

function initCanvasImage() {
    const canvas = document.getElementById('leaflet');

    if (canvas.tagName !== 'CANVAS') {
        return;
    }

    // Aby uživatel nemohl pravým tlačítkem myši stáhnout obrázek.
    canvas.oncontextmenu = function (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    const context = canvas.getContext('2d');
    const url = canvas.dataset.url;
    const img = new Image();

    $.nette.ajax({
        url: url,
        success: function (url) {
            img.src = url;
        }
    });

    img.onload = () => {
        context.drawImage(img, 0, 0);
    };
}

function fixPaginatorPosition() {
    const urlParams = new URLSearchParams(window.location.search);
    const anchor = document.getElementById(urlParams.get('anchor'));
    const additionalHeight = 200;

    if (urlParams.get('anchor') === 'paginator-top')
    {
        window.scrollTo(0, anchor.offsetTop);
    }

    if (urlParams.get('anchor') === 'paginator-bottom')
    {
        window.scrollTo(0, anchor.offsetTop - window.innerHeight + anchor.clientHeight + additionalHeight);
    }
}
